import './search-result-item.styl';

import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';

const SearchResultItem = ({link, onHover, htmlSnippet, htmlTitle, displayLink, locale, useragent = {}}) =>
  <div
    className={classNames({
      'search-result-item': true,
      'search-result-item_onhover': onHover
    })}
  >
    <a
      className="search-result-item__href"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        className="search-result-item__title"
        dangerouslySetInnerHTML={{__html: htmlTitle}}
      />
      <div
        className="search-result-item__snippet"
        dangerouslySetInnerHTML={{__html: htmlSnippet}}
      />
    </a>
    <div>
      <span className="search-result-item__link">
        {displayLink}
      </span>
      {useragent.chrome === false &&
        <a
          className="search-result-item__translate"
          target="_blank"
          href={`https://translate.google.com/translate?ie=UTF-8&tl=${locale}&u=${link}`}
          rel="noopener noreferrer"
        >
          <FormattedMessage id="search.results.item.translate" />
        </a>
      }
    </div>
  </div>;

SearchResultItem.propTypes = {
  link: React.PropTypes.string,
  htmlSnippet: React.PropTypes.string,
  htmlTitle: React.PropTypes.string,
  displayLink: React.PropTypes.string,
  onHover: React.PropTypes.bool
};

export default SearchResultItem;



// WEBPACK FOOTER //
// ./src/client/components/search-results/SearchResultsItem.js